(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zentein-collection-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zen-collection-quick-add')) {
    customElements.define('zen-collection-quick-add', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('[data-zen-add]');
        this.label = this.querySelector('[data-zen-add-label]');
        this.status = this.querySelector('[data-zen-add-status]');
        this.root = this.closest('[data-zen-collection2]');
        if (!this.form || !this.button || this.button.disabled) return;
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
        const originalLabel = this.root.dataset.addLabel;
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const formData = new FormData(this.form);
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('is-loading');
        this.label.textContent = this.root.dataset.addingLabel;
        this.status.textContent = '';

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: formData
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || this.root.dataset.errorLabel);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'zentein-collection2',
              productVariantId: formData.get('id'),
              cartData: result
            });
          }
          if (cart && typeof cart.renderContents === 'function') cart.renderContents(result);
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          this.label.textContent = this.root.dataset.addedLabel;
          this.status.textContent = this.root.dataset.addedLabel;
          this.root.dispatchEvent(new CustomEvent('zentein:collection-add', {
            bubbles: true,
            detail: {
              variantId: formData.get('id'),
              handle: this.closest('[data-product-handle]')?.dataset.productHandle || ''
            }
          }));
          window.setTimeout(() => {
            this.label.textContent = originalLabel;
            this.status.textContent = '';
          }, 2600);
        } catch (error) {
          this.label.textContent = originalLabel;
          this.status.textContent = error.message || this.root.dataset.errorLabel;
        } finally {
          this.button.classList.remove('is-loading');
          this.button.removeAttribute('aria-disabled');
        }
      }
    });
  }

  document.querySelectorAll('[data-zen-collection2]').forEach((root) => {
    if (root.dataset.enhanced === 'true') return;
    root.dataset.enhanced = 'true';
    const track = (event, details = {}) => {
      const payload = { event, collection: root.dataset.collectionHandle || '', ...details };
      window.dataLayer?.push(payload);
      document.dispatchEvent(new CustomEvent(`zentein:${event}`, { detail: payload }));
    };

    root.querySelectorAll('[data-zen-image-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const media = button.closest('[data-zen-media]');
        const active = !media.classList.contains('is-alt');
        media.classList.toggle('is-alt', active);
        button.setAttribute('aria-pressed', String(active));
        track('collection_image_toggled', { handle: button.closest('[data-product-handle]')?.dataset.productHandle || '' });
      });
    });

    root.querySelectorAll('[data-zen-product-link]').forEach((link) => {
      link.addEventListener('click', () => track('collection_product_clicked', {
        handle: link.closest('[data-product-handle]')?.dataset.productHandle || '',
        destination: link.getAttribute('href')
      }));
    });

    root.addEventListener('zentein:collection-add', (event) => track('collection_quick_add', event.detail));
    root.querySelectorAll('[data-zen-helper]').forEach((link) => {
      link.addEventListener('click', () => track(`${link.dataset.zenHelper}_clicked`, { destination: link.getAttribute('href') }));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zentein-z-lab-ingredient-file"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-zif-spotlight]').forEach((section) => {
      const moveSpotlight = (event) => {
        const bounds = section.getBoundingClientRect();
        section.style.setProperty('--spot-x', `${event.clientX - bounds.left}px`);
        section.style.setProperty('--spot-y', `${event.clientY - bounds.top}px`);
        section.dataset.spotActive = 'true';
      };

      section.addEventListener('pointermove', moveSpotlight, { passive: true });
      section.addEventListener('pointerleave', () => {
        section.dataset.spotActive = 'false';
      });
    });

    document.querySelectorAll('[data-zif-tradition]').forEach((explorer) => {
      const tabs = Array.from(explorer.querySelectorAll('[data-zif-tradition-tab]'));
      const panels = Array.from(explorer.querySelectorAll('[data-zif-tradition-panel]'));
      const panelShell = explorer.querySelector('.zif__tradition-panels');

      const activateTradition = (tab) => {
        const target = tab.dataset.zifTraditionTab;
        tabs.forEach((item) => {
          const isSelected = item === tab;
          item.setAttribute('aria-selected', String(isSelected));
          item.tabIndex = isSelected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.zifTraditionPanel !== target;
        });
        if (panelShell) panelShell.dataset.activeTradition = target;
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTradition(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          const nextTab = tabs[(index + direction + tabs.length) % tabs.length];
          activateTradition(nextTab);
          nextTab.focus();
        });
      });
    });

    document.querySelectorAll('[data-zif-vitamin]').forEach((vitaminSection) => {
      const seasonTabs = Array.from(vitaminSection.querySelectorAll('[data-zif-season-tab]'));
      const seasonPanels = Array.from(vitaminSection.querySelectorAll('[data-zif-season-panel]'));
      const seasonOrbit = vitaminSection.querySelector('[data-zif-season-orbit]');

      const activateSeason = (tab) => {
        const target = tab.dataset.zifSeasonTab;
        seasonTabs.forEach((item) => {
          const isSelected = item === tab;
          item.setAttribute('aria-selected', String(isSelected));
          item.tabIndex = isSelected ? 0 : -1;
        });
        seasonPanels.forEach((panel) => {
          panel.hidden = panel.dataset.zifSeasonPanel !== target;
        });
        if (seasonOrbit) seasonOrbit.dataset.zifSeasonOrbit = target;
      };

      seasonTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateSeason(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          const nextTab = seasonTabs[(index + direction + seasonTabs.length) % seasonTabs.length];
          activateSeason(nextTab);
          nextTab.focus();
        });
      });

      const formTabs = Array.from(vitaminSection.querySelectorAll('[data-zif-form-tab]'));
      const formPanels = Array.from(vitaminSection.querySelectorAll('[data-zif-form-panel]'));
      const formsReader = vitaminSection.querySelector('[data-zif-forms-reader]');

      const activateForm = (tab) => {
        const target = tab.dataset.zifFormTab;
        formTabs.forEach((item) => {
          const isSelected = item === tab;
          item.setAttribute('aria-selected', String(isSelected));
          item.tabIndex = isSelected ? 0 : -1;
        });
        formPanels.forEach((panel) => {
          panel.hidden = panel.dataset.zifFormPanel !== target;
        });
        if (formsReader) formsReader.dataset.zifFormsReader = target;
      };

      formTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateForm(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          const nextTab = formTabs[(index + direction + formTabs.length) % formTabs.length];
          activateForm(nextTab);
          nextTab.focus();
        });
      });
    });

    document.querySelectorAll('[data-zif-habitat]').forEach((habitat) => {
      const tabs = Array.from(habitat.querySelectorAll('[data-zif-habitat-tab]'));
      const panels = Array.from(habitat.querySelectorAll('[data-zif-habitat-panel]'));

      const activateTab = (tab) => {
        const target = tab.dataset.zifHabitatTab;
        tabs.forEach((item) => {
          const isSelected = item === tab;
          item.setAttribute('aria-selected', String(isSelected));
          item.tabIndex = isSelected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.zifHabitatPanel !== target;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextTab = tabs[(index + direction + tabs.length) % tabs.length];
          activateTab(nextTab);
          nextTab.focus();
        });
      });
    });

    document.querySelectorAll('[data-zif-research]').forEach((research) => {
      const shell = research.querySelector('.zif__research-shell');
      const tabs = Array.from(research.querySelectorAll('[data-zif-research-tab]'));
      const panels = Array.from(research.querySelectorAll('[data-zif-research-panel]'));

      const activateResearchTab = (tab) => {
        const target = tab.dataset.zifResearchTab;
        tabs.forEach((item) => {
          const isSelected = item === tab;
          item.setAttribute('aria-selected', String(isSelected));
          item.tabIndex = isSelected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.zifResearchPanel !== target;
        });
        if (shell) shell.dataset.activeTopic = target;
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateResearchTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextTab = tabs[(index + direction + tabs.length) % tabs.length];
          activateResearchTab(nextTab);
          nextTab.focus();
        });
      });
    });

    document.querySelectorAll('[data-zif-voices]').forEach((voices) => {
      const shell = voices.querySelector('.zif__voices-shell');
      const tabs = Array.from(voices.querySelectorAll('[data-zif-voices-tab]'));
      const panels = Array.from(voices.querySelectorAll('[data-zif-voices-panel]'));

      const activateVoicesTab = (tab) => {
        const target = tab.dataset.zifVoicesTab;
        tabs.forEach((item) => {
          const isSelected = item === tab;
          item.setAttribute('aria-selected', String(isSelected));
          item.tabIndex = isSelected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.zifVoicesPanel !== target;
        });
        if (shell) shell.dataset.activeVoice = target;
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateVoicesTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextTab = tabs[(index + direction + tabs.length) % tabs.length];
          activateVoicesTab(nextTab);
          nextTab.focus();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zentein-z-lab-superfood-powder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const connectTabs = (root, tabSelector, panelSelector, dataKey) => {
      const tabs = Array.from(root.querySelectorAll(tabSelector));
      const panels = Array.from(root.querySelectorAll(panelSelector));
      const activate = (tab) => {
        const target = tab.dataset[dataKey];
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset[dataKey.replace('Tab', 'Panel')] !== target;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          const next = tabs[(index + direction + tabs.length) % tabs.length];
          activate(next);
          next.focus();
        });
      });
    };

    document.querySelectorAll('[data-spif-ingredients]').forEach((root) => connectTabs(root, '[data-spif-ingredient-tab]', '[data-spif-ingredient-panel]', 'spifIngredientTab'));
    document.querySelectorAll('[data-spif-process]').forEach((root) => connectTabs(root, '[data-spif-process-tab]', '[data-spif-process-panel]', 'spifProcessTab'));
    document.querySelectorAll('[data-spif-history]').forEach((root) => connectTabs(root, '[data-spif-history-tab]', '[data-spif-history-panel]', 'spifHistoryTab'));
    document.querySelectorAll('[data-spif-vitamins]').forEach((root) => connectTabs(root, '[data-spif-vitamin-tab]', '[data-spif-vitamin-panel]', 'spifVitaminTab'));

    document.querySelectorAll('[data-spif-spotlight]').forEach((section) => {
      section.addEventListener('pointermove', (event) => {
        const bounds = section.getBoundingClientRect();
        section.style.setProperty('--spot-x', `${event.clientX - bounds.left}px`);
        section.style.setProperty('--spot-y', `${event.clientY - bounds.top}px`);
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
